import { Box, Typography, Divider } from "@mui/material";
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';

const GeneralInfo = ({ user, profile }) => {
  const getDirecciones = () => {
    if (profile?.direcciones && profile.direcciones.length > 0) {
      return profile.direcciones[0].direccion;
    }
    return "No especificada";
  };

  // El backend oculta correo/celular según la preferencia de privacidad del proveedor.
  const contactoOculto = user?.contactoVisible === false;

  const infoItems = [
    {
      label: "UBICACIÓN",
      value: getDirecciones(),
      icon: <LocationOnOutlinedIcon sx={{ color: '#0E2465' }} />
    },
    {
      label: "TELÉFONO",
      value: contactoOculto ? "No compartido" : (user?.tel || "No especificado"),
      icon: <LocalPhoneOutlinedIcon sx={{ color: '#0E2465' }} />
    },
    {
      label: "CORREO ELECTRÓNICO",
      value: contactoOculto ? "No compartido" : (user?.email || "No especificado"),
      icon: <EmailOutlinedIcon sx={{ color: '#0E2465' }} />
    },
    {
      label: "PÁGINA WEB",
      value: profile?.perfil?.website || "No especificada",
      icon: <LanguageOutlinedIcon sx={{ color: '#0E2465' }} />
    }
  ];

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h5" sx={{ fontWeight: 700, color: '#0E2465', mb: 0.5 }}>
        Información general
      </Typography>
      <Typography variant="body2" sx={{ color: '#737791', display: 'block', mb: 3 }}>
        Sobre {user?.name || 'el proveedor'}
      </Typography>

      <Box className="stats-container-row" sx={{ p: 0 }}>
        {infoItems.map((item, index) => (
          <Box key={index}>
            <Box sx={{ pb: 3, pt: 1, display: 'flex', alignItems: 'flex-start' }}>
              <Box sx={{ mr: 2, mt: 0.5 }}>
                {item.icon}
              </Box>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="caption" color="primary" sx={{ fontWeight: 600, display: 'block' }}>
                  {item.label}
                </Typography>
                <Typography variant="body1" sx={{ wordWrap: 'break-word' }}>
                  {item.value}
                </Typography>
              </Box>
            </Box>
            {index < infoItems.length - 1 && <Divider sx={{ mb: 3 }} />}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default GeneralInfo;
